import { FormattedMessage } from "react-intl";
import { useCuideoDiscardedValuations } from "../../features/valuation";
import DiscardedValuationsTable from "./DiscardedValuationsTable";

interface ICuideoDiscardedValuationsTableProps {
  candidateId: string;
}

const CuideoDiscardedValuationsTable = (
  props: ICuideoDiscardedValuationsTableProps
) => {
  const { candidateId } = props;

  const valuationsQuery = useCuideoDiscardedValuations({
    params: { candidateId },
  });

  return (
    <DiscardedValuationsTable
      status={valuationsQuery.status}
      rows={valuationsQuery.data?.["hydra:member"].map((valuation) => ({
        id: valuation.id,
        contratoName: valuation.contratoName,
        statusUpdatedAt: valuation.statusUpdatedAt,
        reason: valuation.cuideo_discard_reason,
      }))}
      emptyMessage={
        <FormattedMessage
          id="CuideoDiscardedValuationsTable.Cuideo no ha descartado a este candidato/a"
          defaultMessage="Cuideo no ha descartado a este candidato/a"
        />
      }
    />
  );
};

export default CuideoDiscardedValuationsTable;
